(ns admin.components.forms.fields.related-resources
  (:require
   [reagent-form.utils :refer [initialize-field!
                               update-field-value!
                               get-field-value]]

   [kyber.styles.core :refer [gs styles->classes]]
   [kyber.components.composite.resource-icon-preview
    :as resource-icon-preview]
   [kyber.components.base.text :as text]
   [kyber.components.composite.checkbox :as checkbox]))

(def classes
  (styles->classes
   {:container
    {:border (str "1px solid " (gs [:colors :gray-scale-100]))
     :background-color (gs [:colors :gray-scale-50])
     :padding (gs [:spacing :p20])}

    :resource-list-container
    {:width "100%"
     :max-height "400px"
     :overflow-y :scroll}

    :resource-container
    {:display :flex
     :align-items :center
     :justify-content :space-between
     :border-top (str "1px solid " (gs [:colors :gray-scale-200]))
     :border-left (str "1px solid " (gs [:colors :gray-scale-200]))
     :padding [(gs [:spacing :p8])
               (gs [:spacing :p20])]
     :width "100%"}

    :inner-resource-container
    {:display :flex
     :justify-content :space-between
     :align-items :flex-start}}))

(defn- render-resource-selection
  [{:keys [on-change resource default-value]}]
  (let [{resource-name :resource/name
         resource-uuid :resource/uuid} resource]
    [:div {:class (:resource-container classes)}
     [:div {:class (:inner-resource-container classes)}
      [resource-icon-preview/render resource]
      [text/title-10 :p
       {:style {:margin (gs [:spacing :p0])}}
       resource-name]]
     [checkbox/render-v2 {:on-change #(on-change % resource-uuid)
                          :default-value default-value}]]))

(defn render
  [{:keys [node form-state]}]
  (let [params
        (second node)

        {:keys [field-key
                default-value
                all-resources]}
        (:rf/custom-field params)

        on-change
        (fn [resource-exists resource-uuid]
          (let [current-value (get-field-value @form-state field-key)
                updated-value (if (true? resource-exists)
                                (conj current-value resource-uuid)
                                (disj current-value resource-uuid))]
            (update-field-value! form-state field-key updated-value)))]

    (initialize-field! form-state
                       field-key
                       {:default-errors []
                        :default-hints []
                        :default-value (or default-value #{})
                        :hint-triggers []
                        :masks []
                        :transformers []
                        :validators []})

    (fn []
      (let [current-value (get-field-value @form-state field-key)]
        [:div {:class (:container classes)}
         [:div {:class (:header-container classes)}
          [text/caption-30 :p
           {:style {:color (gs [:colors :gray-scale-500])}}
           "Select the resources you would like to include in this boost."]
          [text/caption-10 :p
           {:style {:color (gs [:colors :gray-scale-400])}}
           "Sorted by title (A-Z)"]]
         [:ul {:class (:resource-list-container classes)}
          (for [{resource-uuid :resource/uuid :as resource}
                (sort-by :resource/name all-resources)]
            ^{:key resource-uuid}
            [render-resource-selection
             {:on-change on-change
              :resource resource
              :default-value (contains? current-value resource-uuid)}])]]))))
